import { toast } from 'react-toastify';
import { app } from './firebaseConfig';

import {
    getFirestore,
    collection,
    addDoc,
    doc,
    setDoc,
    limit,
    where,
    query,
    orderBy,
    getDocs,
    getDoc
} from "firebase/firestore";

const db = getFirestore(app);

interface HistoricalDataProps {
    dateStart?: number
    dateEnd?: number,
    collectionName: string
}

const addDocument = async (collectionName: string, data: any) => {
    try {
        const col = collection(db, collectionName);
        const response = await addDoc(col, data);

        return response;

    } catch (err) {
        // @ts-ignore
        if (err) {
            toast.error('Existe un error, intente más tarde');
        }
        console.error(err);
    }
}

const setDocument = async (documentId: string, collectionName: string, data: any) => {
    try {
        const document = doc(db, `${collectionName}/${documentId}`);
        await setDoc(document, data, { merge: true });

        return true;

    } catch (err) {
        // @ts-ignore
        if (err) {
            toast.error('Existe un error, intente más tarde');
        }
        console.error(err);
    }
}

// const updateArray = (documentId, collectionName, keyName, arrayData) => {
//     const document = doc(db, `${collectionName}${documentId}`);
//     return setDoc(document, { answers: { [keyName]: arrayUnion(...arrayData) } }, { merge: true });
// }

const getCollectionByProperties = async ({ dateStart, dateEnd, collectionName }: HistoricalDataProps) => {
    try {
        let queryConstraint = [];
        queryConstraint.push(orderBy('timestamp', 'desc'));

        if (!dateStart && !dateEnd) {
            queryConstraint.push(limit(200))
        }
        else {
            queryConstraint.push(where('timestamp', '>=', dateStart));
            queryConstraint.push(where('timestamp', '<=', dateEnd));
        }

        const queryStatement = query(
            collection(db, collectionName),
            ...queryConstraint
        )
        const response = await getDocs(queryStatement);

        return response;

    } catch (err) {
        // @ts-ignore
        if (err) {
            toast.error('Existe un error, intente más tarde');
        }
        console.error(err);
    }
}

const getCollection = async (collectionName: string) => {
    try {
        const queryStatement = query(
            collection(db, collectionName)
        )
        const response = await getDocs(queryStatement);

        return response;

    } catch (err) {
        // @ts-ignore
        if (err) {
            toast.error('Existe un error, intente más tarde');
        }
        console.error(err);
    }
}

export {
    db,
    addDocument,
    setDocument,
    getCollectionByProperties,
    getCollection
}